import React, { FC, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';

import { CustomListProps } from '../types';
import CustomListItem from '../CustomListItem';

import styles from './index.module.scss';

const CustomList: FC<CustomListProps> = ({ className, selectedItemId: selectedItemIdProp, items, onChange }) => {
  const [selectedItemId, setSelectedItemId] = useState<string>(selectedItemIdProp);

  useEffect(() => {
    setSelectedItemId(selectedItemIdProp);
  }, [selectedItemIdProp]);

  const handleChange = useCallback(
    (selectedId: string) => {
      setSelectedItemId(selectedId);
      onChange(selectedId);
    },
    [onChange]
  );

  return (
    <div className={classNames(styles.customList, className)}>
      {items.map((item) => (
        <CustomListItem
          key={item.id}
          id={item.id}
          elementId={item.id}
          contentId={item.contentId}
          content={item.content}
          footer={item.footer}
          isSelected={item.id === selectedItemId}
          switcherHidden={items.length === 1}
          onChange={handleChange}
        />
      ))}
    </div>
  );
};

export default React.memo(CustomList);
